import type { Employee as EmployeeModel } from '@/adapters/catalogv1.g';

export function extractEmployee(model: EmployeeModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    ref: model.employee_ref ?? '',
    employeeId: model.employee_id,
    firstName: model.first_name,
    lastName: model.last_name,
    fullName:
      [model.first_name, model.last_name].filter(Boolean).join(' ') ||
      model.employee_ref ||
      '',
    title: model.title,
    department: model.department,
    status: model.status,
    managerRef: model.manager_ref,
    primaryEmail: model.primary_email?.address,
    primaryPhone: model.primary_phone?.number,
    hiredOn: model.hired_on ? new Date(model.hired_on) : undefined,
    createdAt: model.created_at ? new Date(model.created_at) : undefined,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogEmployee = ReturnType<typeof extractEmployee>;
